import { ecosystemLinks } from "@/config/ecosystem";
import { LazyImage } from "@/components/ui/lazy-image";

export const EcosystemBar = () => (
  <nav
    className="w-full bg-card/60 backdrop-blur-sm border-b border-border/40"
    aria-label="GenieBot ecosystem"
  >
    <div className="max-w-6xl mx-auto px-4 py-3">
      <p className="text-xs text-muted-foreground text-center mb-2 sm:mb-3">
        The GenieBot Family
      </p>
      <ul className="flex flex-nowrap overflow-x-auto sm:flex-wrap sm:justify-center gap-2 sm:gap-3 -mx-1 px-1 snap-x snap-mandatory">
        {ecosystemLinks.map((link) => {
          const card = (
            <figure className="m-0 w-full">
              <div className="relative aspect-[16/10] w-full overflow-hidden rounded-md bg-muted">
                <LazyImage
                  src={link.cover}
                  alt={`${link.label} preview`}
                  aspectRatio="auto"
                  className="h-full w-full object-cover object-top transition-transform duration-300 motion-reduce:transition-none group-hover:scale-105 motion-reduce:group-hover:scale-100 group-focus-within:scale-105 motion-reduce:group-focus-within:scale-100"
                  sizes="(max-width: 640px) 144px, (max-width: 768px) 160px, 176px"
                />
                {/* Always-visible label with gradient scrim for legibility over dark covers */}
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" aria-hidden="true" />
                <figcaption className="absolute inset-x-0 bottom-0 flex flex-col items-center px-2 pb-2 text-center">
                  <span
                    className={
                      link.active
                        ? "text-xs sm:text-sm font-semibold text-primary drop-shadow"
                        : "text-xs sm:text-sm font-semibold text-white drop-shadow"
                    }
                  >
                    {link.label}
                  </span>
                  {link.tagline && (
                    <span className="mt-0.5 text-[10px] sm:text-xs text-white/80 line-clamp-1">
                      {link.tagline}
                    </span>
                  )}
                </figcaption>
              </div>
            </figure>
          );

          return (
            <li
              key={link.href}
              className="snap-start shrink-0 w-36 sm:w-40 md:w-44"
            >
              {link.active ? (
                <div
                  aria-current="page"
                  className="group block rounded-lg border-2 border-primary/60 bg-primary/5 p-1.5"
                >
                  {card}
                </div>
              ) : (
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit ${link.label}`}
                  className="focus-ring group block rounded-lg border border-border/60 bg-background/40 p-1.5 transition-all motion-reduce:transition-none hover:border-primary/50 hover:bg-primary/5 hover:-translate-y-0.5 motion-reduce:hover:translate-y-0"
                >
                  {card}
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  </nav>
);
